import axios from "axios";
import qs from "Qs";
/* eslint-disable */
// <!--打包前换成线上代理，本地代理是本地开发用20220308byfgq-->
// export const baseURL = "/api" // 开发本地代理
export const baseURL = "../.." //线上
// 视频列表
export function getCategories() {
	return template("/course/getCategories");
}

export function pageCourse(ccid) {
	return template("/course/pageCourse", qs.stringify({ row: 100, ccid }));
}

export function getCourse(cid) {
	return template("/course/getCourse", qs.stringify({ cid }));
}

export function checkVideo(videoId,vid) {
	return template("/course/checkVideo", qs.stringify({ videoId ,vid}));
}

export function getExamQuestions(vid) {
	return template("/course/getExamQuestions", qs.stringify({ vid }));
}

export function sendSMS(phone) {
	return template("/user/sendSMS", qs.stringify({ phone }));
}

export function phoneLogin(phone, SMSCode) {
	return template("/user/phoneLogin", qs.stringify({ phone, SMSCode }))
}

export function phoneRegist(phone, SMSCode) {
	return template("/user/phoneRegist", qs.stringify({phone,SMSCode}))
}

export function getUserMsg() {
	return template("/user/getUserMsg", qs.stringify({}))
}

export function addVideoDuration(duration, vid) {
	return template("/course/addVideoDuration", qs.stringify({ duration, vid }));
}

export function pageCourseSchedule(page, row, studentUid) {
	return template("/course/pageCourseSchedule",studentUid?qs.stringify({ page, row ,studentUid}):qs.stringify({ page, row }))
}

export function logout(){
	return template("/user/logout", qs.stringify({}))
}

export function pageStudent(page,row,cid){
	return template("/user/pageStudent",qs.stringify({page,row,cid}))
}
export function exportStudent(cid){
	return template("/user/exportStudent",qs.stringify({cid}));
}

export function updateRegistNameAndId(name,id,company){
	return template("/user/updateRegistNameAndID",qs.stringify({name,id,company}))
}

export function checkPayStatus(){
	return template("/pay/checkPayStatus",qs.stringify({}))
}

export function pageCoursePaySelection(page,row){
	return template("/course/pageCoursePaySelection",qs.stringify({page,row}))
}

export function buyCourses(cids){
	return template("/course/buyCourses"+cids,qs.stringify({}))
}
export function checkCourseRight(){
	return template("/course/checkCourseRight",qs.stringify({}))
}
export function getUserEDA(){
	return template("/user/getUserEDA",qs.stringify({}))
}


export function examine(data){
	return axios({
		url:`${baseURL}/course/examine`,
		method:'post',
		data:JSON.stringify(data),
		headers:{
			'Content-Type': 'application/json'
		}
	}).then(res=>{
		return Promise.resolve(res.data);
	}).catch(res => {
		return Promise.resolve({ code: -1, message: "网络错误" })
	})
}


function template(url, params) {
	return axios.post(`${baseURL}${url}`, params).then(res => {
		return Promise.resolve(res.data);
	}).catch(error => {
		console.log(error)
		if(error && error.response){
			return Promise.resolve({ code: -1, msg: error.response.status+"错误",before:-1 })
		}else{
			return Promise.resolve({ code: -1, msg: "网络出现错误，请稍后重试",before:-1 })
		}
	})
}
// 清晰度组件
export class QualityComponent {
	constructor() {
		this.html = document.createElement("div");
		this.html.setAttribute("class", "quality-components");
		this.html.innerHTML = `<div class="current-quality" data-ref="">清晰度</div>
					   <ul class="quality-list">
					   </ul>`

		this.modalHtml = document.createElement("div");
		this.modalHtml.setAttribute("class", "quality-modal");
		this.modalHtml.innerHTML = "正在为您切换到 <span></span> , 请稍后..."
		this.hasCreated = false
		this.definition = ""
	}

	createEl(el, player) {
		let eleControlbar = el.querySelector(".prism-controlbar")
		eleControlbar.appendChild(this.html)
		el.appendChild(this.modalHtml)
	}

	setCurrentQuality(quality, def) {
		let currentQuality = this.html.querySelector(".current-quality")
		currentQuality.innerText = quality
		currentQuality.dataset.def = def
		this.definition = def

		let qualityListEle = this.html.querySelector(".quality-list")
		let currentEle = qualityListEle.querySelector(".current")
		if (currentEle) {
			currentEle.className = ""
		}
		let li_target = qualityListEle.querySelector(`li[data-def=${def}]`)
		if (li_target) {
			li_target.className = "current"
		}
	}

	created(player) {
		this._urls = player._urls
		this.setCurrentQuality(this._urls[2].desc, this._urls[2].definition)
		let currentQualityEle = this.html.querySelector(".current-quality")
		let qualityListEle = this.html.querySelector(".quality-list")
		let lis_ele = this._urls.map(url => {
			return `<li data-def="${url.definition}">${url.desc}</li>`
		})
		this.html.querySelector(".quality-list").innerHTML = lis_ele.join("")
		if (this.hasCreated == false && this.definition) {
			let li_target = qualityListEle.querySelector(`li[data-def=${this.definition}]`)
			li_target.className = "current"
		}
		this.hasCreated = true
		let timeId = null
		currentQualityEle.onclick = () => {
			qualityListEle.style.display = "block"
		}
		currentQualityEle.onmouseleave = () => {
			timeId = setTimeout(() => {
				qualityListEle.style.display = "none"
			}, 100);
		}

		qualityListEle.onmouseenter = () => {
			clearTimeout(timeId)
		}
		qualityListEle.onmouseleave = () => {
			qualityListEle.style.display = "none"
		}

		qualityListEle.onclick = ({ target }) => {
			let definition = target.dataset.def
			if (definition) {
				if (target.className !== "current") {
					let url = this._urls.find(url => url.definition === definition)
					player.loadByUrl(url.Url, player.getCurrentTime(), true, true)

					this.setCurrentQuality(url.desc, url.definition)

					this.modalHtml.style.display = "block"
					this.modalHtml.querySelector("span").innerText = url.desc
				}
			}
		}
	}

	ready(player) {
		this.modalHtml.style.display = "none"
	}
}
/* eslint-disable */


// WEBPACK FOOTER //
// ./src/assets/js/axios.js